module.exports = __webpack_public_path__ + "media/images/games/k2gender/catpd-51bcd9812b7faf6bf5f8c639d50fd26e.png";